module.exports = __webpack_public_path__ + "static/media/img_1_1685965116791.cf2ede28.jpg";